import type { Page } from '../../../types';

/**
 * Destino do CTA após a tela de conclusão do onboarding.
 * Conversas — próximo passo natural no CRM WhatsApp.
 */
export function resolvePostOnboardingPage(_saved?: string | null): Page {
  return 'chat';
}
